import { Box, Typography, Button } from "@mui/material";
import React from "react";

// Define the Motivation component
const Motivation = () => {
  return (
    <>
      {/* Main container for the motivation section */}
      <div className="systemStory" style={{ backgroundColor: "#111111" }}>
        <Box
          className="container"
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            py: 6,
            px: 6,
            color: "#fff",
          }}
        >
          {/* Section title */}
          <Typography
            variant="h4"
            sx={{
              fontWeight: 800,
              mt: 1,
              textAlign: "center",
              textTransform: "uppercase",
              color: "#fff",
              fontSize: {
                xs: "15px",
                sm: "20px",
                md: "25px",
                lg: "30px",
              },
              mx: "auto",
              maxWidth: { xs: "100%", sm: "80%", md: "75%", lg: "56%" },
            }}
          >
            Why Do You Want to Change?
          </Typography>

          {/* Subtitle */}
          <Typography
            variant="subtitle1"
            sx={{
              mt: 3,
              color: "#fff",
              fontSize: "15px",
              fontWeight: "700",
            }}
          >
            Set your goal, define your why — and we’ll build your plan around
            it.
          </Typography>
          {/* Call-to-action button */}
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#00ffff",
              color: "#111111",
              fontSize: {
                xs: "12px",
                sm: "12px",
                md: "12px",
                lg: "12px",
                xl: "12px",
              },
              marginTop: {
                xs: "12px",
                sm: "25px",
                md: "26px",
                lg: "20px",
              },
              fontWeight: 700,
              padding: {
                xs: "10px 20px",
                sm: "12px 24px",
                md: "13px 26px",
                lg: "14px 28px",
                xl: "15px 30px",
              },
              borderRadius: "25px",
              textTransform: "uppercase",
              letterSpacing: "1px",
              transition: "all 0.3s ease",
              minWidth: "auto",
              whiteSpace: "nowrap",
              "&:hover": {
                backgroundColor: "#00ffff",
                transform: "translateY(-2px)",
                boxShadow: "0 4px 12px rgba(0, 198, 194, 0.3)",
              },
            }}
            onClick={() => {
              const section = document.getElementById("subscription-section");
              if (section) {
                section.scrollIntoView({ behavior: "smooth" });
              }
            }}
          >
            Start Your Plan Today — $49
          </Button>
        </Box>
      </div>
    </>
  );
};

// Export the Motivation component
export default Motivation;